import React from 'react'

import PropTypes from 'prop-types'

import MTButton from '../MTButton/MTButton'

import { getMtVessels } from '../../../../api/getApi'
import { notify } from '../../../../helpers/notify'

const MTButtonWithSearch = ({ value, onError, onSuccess, Icon }) => {
  const runNextStep = async () => {
    try {
      const response = await getMtVessels(value)

      if (response.error || response.errors || response.__info) {
        const errorMessage =
          response.error?.message ||
          response.errors?.[0]?.message ||
          'The request is not available, waiting time 2 minutes.'

        notify.error('Error', errorMessage)
      } else if (response.results?.length) {
        onSuccess(response)
      } else {
        onError('NOT_FOUND')
      }
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <MTButton onClick={runNextStep} Icon={Icon}>
      Search in
    </MTButton>
  )
}

MTButtonWithSearch.propTypes = {
  value: PropTypes.string.isRequired,
  onError: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  Icon: PropTypes.element,
}

export default MTButtonWithSearch
